import { cn } from '@/lib/utils'

const APP_VERSION = 'v0.9.3'

interface BrandLogoProps {
  size?: 'sm' | 'md'
  showText?: boolean
  showLogo?: boolean
  className?: string
}

export function BrandLogo({
  size = 'md',
  showText = true,
  showLogo = true,
  className,
}: BrandLogoProps) {
  const iconSize = size === 'sm' ? 24 : 28

  return (
    <div className={cn('flex items-center gap-2', className)}>
      {showLogo && (
      <img
        src="/AV8-logo-only-64.png"
        alt="AV8"
        width={iconSize}
        height={iconSize}
        className="shrink-0 rounded-[5px]"
      />
      )}
      {showText && (
        <span className="text-md font-bold tracking-tight">
          <span className="text-sidebar-foreground">Plane</span>
          <span style={{ color: '#1b449d' }}>MAX</span>
          <span className="ml-1 text-[10px] font-normal text-muted-foreground">{APP_VERSION}</span>
        </span>
      )}
    </div>
  )
}
